import React from 'react'
import { useSelector } from 'react-redux'
import { selectIsInChat } from 'selectors/location'
import HotkeysGroup from './HotkeysGroup'

const inboxActions = {
  '?': 'View shortcut overview screen',
  'shift+n': 'Open new conversation',
}

const chatActions = {
  '?': 'View shortcut overview screen',
}

export default function Other() {
  const isInChat = useSelector(selectIsInChat)
  return (
    <HotkeysGroup
      title="Other"
      hotkeys={isInChat ? chatActions : inboxActions}
    />
  )
}
